import SensorOccupiedOutlinedIcon from '@mui/icons-material/SensorOccupiedOutlined';
const icons = { SensorOccupiedOutlinedIcon };

// ==============================|| MENU ITEMS - DRIVER MANAGEMENT ||============================== //

const driverManagement = {
  id: 'driver-management',
  type: 'group',
  children: [
    {
      id: 'driver-management',
      title: 'Driver Management',
      type: 'item',
      url: '/driver-management',
      icon: icons.SensorOccupiedOutlinedIcon
    }
  ]
};

export default driverManagement;
